var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLoginHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "70px",
    viewBox: "0 0 63 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kabriol_head_face") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "65.6799489%",
    x2: "50%",
    y2: "140.466915%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5D2D",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5725",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "69.0900325%",
    x2: "24.1852148%",
    y2: "3.55966661%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5725",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA95F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.6129409%",
    y1: "8.1850795%",
    x2: "47.7500354%",
    y2: "118.78362%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF54",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA12A",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCF1-Application-iOS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-web---Connexion",
    transform: "translate(-688.000000, -102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kabriol_head_face",
    transform: "translate(688.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 31.5,
    cy: 38.7642526,
    rx: 31.5,
    ry: 31.2357474
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,70 C41.1382015,70 49.7653815,65.7076159 55.5434941,58.9454742 C55.6194294,58.8566069 56.742735,57.5011626 57.7035655,56.1269636 C58.2087383,55.4044553 58.970873,54.0677921 59.9899697,52.1169739 C56.4375457,53.9160348 53.8725298,54.9213448 52.2949219,55.1329037 C51.0566383,55.2989589 49.1869423,55.4117175 46.6858337,55.4711795 L46.6858346,55.4712182 C45.354574,55.5033668 44.1125373,56.1476798 43.3195676,57.217487 C40.0194246,61.6758558 36.0550912,63.904418 31.428246,63.904418 C26.8292505,63.904418 22.9600807,61.7026031 19.8207368,57.2989733 L19.8192581,57.3000293 C19.0223672,56.1840961 17.7430014,55.5127694 16.3719172,55.4910921 C13.7232402,55.4492181 11.7055444,55.329822 10.3188298,55.1329037 C8.55759475,54.8828023 6.12658576,53.8774923 3.02580281,52.1169739 C4.14163367,54.1822919 4.89636581,55.4953218 5.28999922,56.0560638 C6.51620774,57.8028327 7.34005467,58.809191 7.45650588,58.9454742 C13.2346185,65.7076159 21.8617985,70 31.5,70 Z",
    id: "Oval",
    fill: "#FEA12B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5210542,1.92629764 C35.1178407,0.440688942 36.431381,-0.491519701 37.6566199,0.273464028 C38.8818587,1.03844776 38.6499081,2.43451303 38.1589884,4.82201405 C37.9514604,5.8312897 37.5415907,6.88753479 36.9293792,7.99074934 C50.6164744,10.3477941 61.2740469,21.4675807 62.8096168,35.3104075 C62.814649,35.3557719 62.8127623,35.4123904 62.8044021,35.479359 L62.8095717,35.4801669 C62.7030402,37.3330444 62.5078715,38.6652561 62.2240655,39.4768019 C61.2304196,42.3181413 59.7080737,44.1159947 58.5919918,45.064376 C53.8724081,49.0748029 46.5083748,48.186747 44.4374711,48.62715 C42.3665675,49.067553 41.4039366,51.5523895 38.9801931,54.0713314 C36.7307597,56.4091168 33.6823411,58.3541376 31.5307617,58.3541376 C29.4871236,58.3541376 26.6062712,56.7332383 24.4081728,54.5259342 C21.7985464,51.9053787 20.8286775,48.9660327 18.5800993,48.62715 C16.331521,48.2882673 8.94721488,49.3029529 3.7337227,44.3540919 C2.56706811,43.2466554 1.44061019,41.8997331 0.725171718,39.4768019 C0.504212337,38.7284924 0.31337742,37.4682056 0.152666967,35.6959415 L0.162900822,35.6933917 C0.157771824,35.6608744 0.156381525,35.6321049 0.158895185,35.6072704 C1.62116269,21.1603358 13.0109399,9.61614263 27.4626478,7.78267499 C26.976531,6.86096995 26.6902151,6.01395488 26.6040967,5.24232835 C26.4094133,3.49795239 26.4376498,2.20446945 27.5262449,1.79563064 C28.6148399,1.38679182 29.8159539,2.67257708 30.724789,3.69473823 C30.9734326,3.97438609 31.2395112,4.36897837 31.523025,4.87851506 C32.1043329,3.60815166 32.7704079,2.62467938 33.5210542,1.92629764 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#282E3D",
    cx: 49.8339844,
    cy: 38.7642526,
    rx: 4.06054688,
    ry: 4.02648306
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 50.7568359,
    cy: 37.7271282,
    rx: 1.53808594,
    ry: 1.52518298
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#282E3D",
    cx: 13.2890625,
    cy: 38.7642526,
    rx: 4.06054688,
    ry: 4.02648306
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 14.2119141,
    cy: 37.7271282,
    rx: 1.53808594,
    ry: 1.52518298
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.571754,40.969966 C33.5118937,40.969966 35.0846877,42.54276 35.0846877,44.4828997 C35.0846877,44.7145921 35.0617662,44.9457162 35.0162357,45.1728909 C34.0135575,50.1783264 32.8414789,52.6810441 31.5,52.6810441 C30.1594403,52.6810441 29.0186752,50.181755 28.0777048,45.1831767 C27.7143932,43.2534507 28.9842651,41.3946053 30.9139994,41.0313374 C31.1308712,40.9905118 31.351073,40.969966 31.571754,40.969966 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-3)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginHeader);
export default __webpack_public_path__ + "static/media/icon-login-header.61516007.svg";
export { ForwardRef as ReactComponent };